import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M2 17.538v-2h9v2Zm0-8v-2h9v2Zm14.375 10-3.55-3.55 1.4-1.4 2.125 2.125 4.25-4.25 1.4 1.425Zm0-8-3.55-3.55 1.4-1.4 2.125 2.125 4.25-4.25L22 5.888Z" }, null, -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "FinalizeAll"}) } }